import React, {useEffect} from 'react';

import etoroLogo from "../images/etoro-logo.svg";
import boursierLogo from "../images/boursier-logo.svg";

import styles from "./Header.module.scss"
import Image from "../components/Global/Image";
import {useLocation} from 'react-router-dom';
import {detectAnyAdblocker} from 'just-detect-adblock';


export default function Header () {
    const location = useLocation()

    useEffect(() => {
        detectAnyAdblocker().then(detected => {
            if (detected) {
                const adButtons = document.querySelectorAll('[href*="https://ad.doubleclick.net/"]');
                const newUrl = 'https://go.etoro.com/fr/smart-portfolios/tech?utm_medium=Content%20Partnerships&utm_source=109189&utm_content=20139&utm_serial=343846156&utm_campaign=343846156&utm_term=&Source=Media&dclid=CNr3y7HDoPoCFVBGHQkdqbwH8A';

                Object.values(adButtons).map(button => button.href = newUrl);
            }
        });
    }, [location]);

    return (
        <>
            <header className={styles.Main}>
                <div className={'container'}>
                    <a href="https://ad.doubleclick.net/ddm/clk/549052260;358217871;k" target={'_blank'} rel={'noreferrer'} className={styles.Logo}>
                        <Image src={etoroLogo}/>
                    </a>

                    <span className={styles.Boursier}>
                    en partenariat avec
                    <Image src={boursierLogo} alt="Boursier.com"/>
                </span>
                </div>
            </header>
        </>
    )
}
